import {
    singleLocationUnavailable,
    multipleLocationsUnavailable,
    singleAttendeeUnavailable,
    singleLocationAndSingleAttendeeUnavailable,
    multipleLocationsAndSingleAttendeeUnavailable,
    multipleAttendeesUnavailable,
    singleLocationAndMultipleAttendeesUnavailable,
    multipleLocationsAndMultipleAttendeesUnavailable,
    organizerUnavailable,
    singleLocationAndOrganizerUnavailable,
    multipleLocationsAndOrganizerUnavailable,
    singleAttendeeAndOrganizerUnavailable,
    singleLocationSingleAttendeeAndOrganizerUnavailable,
    multipleLocationsSingleAttendeeAndOrganizerUnavailable,
    multipleAttendeesAndOrganizerUnavailable,
    singleLocationMultipleAttendeesAndOrganizerUnavailable,
    multipleLocationsMultipleAttendeesAndOrganizerUnavailable,
} from './getConflictsString.locstring.json';
import { everyoneAvailable } from 'owa-locstrings/lib/strings/everyoneavailable.locstring.json';
import { organizerAvailableTitle } from '../strings.locstring.json';
import loc, { format } from 'owa-localize';
import AttendeeType from 'owa-service/lib/contract/AttendeeType';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import hasUnknownFreeBusyAttendee from './hasUnknownFreeBusyAttendee';
import { DisplayDate } from 'owa-datetime';

/**
 * Returns a user-friendly string for the event's conflicts
 * @param allAttendees all the attendee of the meeting event
 * @param allAttendeesExceptOrganizer all the attendee of the meeting event except the organizer
 * @param start start display date
 * @param end end display date
 * @param isAllDayEvent whether the meeting is an all day event
 * @param originalEvent the original calendar event
 * @param organizerConflict True if the organizer is unavailable
 * @param attendeeConflictCount Number of attendees that are unavailable
 * @param locationConflictCount Number of locations that are unavailable
 */
export default function getConflictString(
    allAttendees: AttendeeType[],
    allAttendeesExceptOrganizer: AttendeeType[],
    start: DisplayDate,
    end: DisplayDate,
    isAllDayEvent: boolean,
    originalEvent: CalendarEvent,
    organizerConflict: boolean,
    attendeeConflictCount: number,
    locationConflictCount: number
): string {
    if (!organizerConflict) {
        switch (attendeeConflictCount) {
            case 0:
                switch (locationConflictCount) {
                    case 0:
                        if (
                            allAttendeesExceptOrganizer.length === 0 ||
                            hasUnknownFreeBusyAttendee(
                                allAttendees,
                                start,
                                end,
                                isAllDayEvent,
                                originalEvent
                            )
                        ) {
                            return loc(organizerAvailableTitle);
                        } else {
                            return loc(everyoneAvailable);
                        }
                    case 1:
                        return loc(singleLocationUnavailable);
                    default:
                        return format(loc(multipleLocationsUnavailable), locationConflictCount);
                }
            case 1:
                switch (locationConflictCount) {
                    case 0:
                        return loc(singleAttendeeUnavailable);
                    case 1:
                        return loc(singleLocationAndSingleAttendeeUnavailable);
                    default:
                        return format(
                            loc(multipleLocationsAndSingleAttendeeUnavailable),
                            locationConflictCount
                        );
                }
            default:
                switch (locationConflictCount) {
                    case 0:
                        return format(loc(multipleAttendeesUnavailable), attendeeConflictCount);
                    case 1:
                        return format(
                            loc(singleLocationAndMultipleAttendeesUnavailable),
                            attendeeConflictCount
                        );
                    default:
                        return format(
                            loc(multipleLocationsAndMultipleAttendeesUnavailable),
                            attendeeConflictCount,
                            locationConflictCount
                        );
                }
        }
    }
    switch (attendeeConflictCount) {
        case 0:
            switch (locationConflictCount) {
                case 0:
                    return loc(organizerUnavailable);
                case 1:
                    return loc(singleLocationAndOrganizerUnavailable);
                default:
                    return format(
                        loc(multipleLocationsAndOrganizerUnavailable),
                        locationConflictCount
                    );
            }
        case 1:
            switch (locationConflictCount) {
                case 0:
                    return loc(singleAttendeeAndOrganizerUnavailable);
                case 1:
                    return loc(singleLocationSingleAttendeeAndOrganizerUnavailable);
                default:
                    return format(
                        loc(multipleLocationsSingleAttendeeAndOrganizerUnavailable),
                        locationConflictCount
                    );
            }
        default:
            switch (locationConflictCount) {
                case 0:
                    return format(
                        loc(multipleAttendeesAndOrganizerUnavailable),
                        attendeeConflictCount
                    );
                case 1:
                    return format(
                        loc(singleLocationMultipleAttendeesAndOrganizerUnavailable),
                        attendeeConflictCount
                    );
                default:
                    return format(
                        loc(multipleLocationsMultipleAttendeesAndOrganizerUnavailable),
                        attendeeConflictCount,
                        locationConflictCount
                    );
            }
    }
}
